module.exports = "/static/assets/ec14005976de0c416291669942e660b9.png";